export default __webpack_public_path__ + "static/media/request__accepted.35dfa4a4.svg";